<template>
  <v-container class="mt-4">
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-autocomplete :items="portalCustomers" item-text="customerName" item-value="customerId" v-model="customerId"
                        label="Customer" dense outlined hide-details
                        no-data-text="No portal customers created"
                        @change="$emit('input',customerId)"/>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" sm="6">

        <outlined-block title="Inventory available in portal">
          <v-tabs class="my-2">

            <v-tab>Products</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddProduct">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleProducts.length"
                                @click="id=eligibleProducts[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <multi-level-select v-if="productCategories.length" label="Product to add" outlined
                                        :menuData="productsInCategories" :second.sync="id"/>
                          <v-autocomplete v-else label="Product to add" v-model="id"
                                  :items="eligibleProducts" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddProduct=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addProduct()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Product</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in products" :key="id">
                    <td><v-btn icon @click.stop="deleteProduct(id,index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allProducts.find(p => p.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab>Items</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddItem">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleItems.length"
                                @click="id=eligibleItems[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <multi-level-select v-if="itemCategories.length" label="Item to add" outlined
                                        :menuData="itemsInCategories" :second.sync="id"/>
                          <v-autocomplete v-else label="Item to add" v-model="id"
                                  :items="eligibleItems" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddItem=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addItem()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in items" :key="id">
                    <td><v-btn icon @click.stop="deleteItem(id, index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allItems.find(p => p.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab>Spirits</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddSpirit">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleSpirits.length"
                                @click="id=eligibleSpirits[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <v-autocomplete label="Spirit to add" v-model="id"
                                  :items="eligibleSpirits" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddSpirit=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addSpirit()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Spirit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in spirits" :key="id">
                    <td><v-btn icon @click.stop="deleteSpirit(id, index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allSpirits.find(p => p.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab>Wines</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddWine">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleWines.length"
                                @click="id=eligibleWines[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <v-autocomplete label="Wine to add" v-model="id"
                                  :items="eligibleWines" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddWine=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addWine()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Wine</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in wines" :key="id">
                    <td><v-btn icon @click.stop="deleteWine(id, index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allWines.find(p => p.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

          </v-tabs>
        </outlined-block>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'AppsPortalInventory',
  mixins: [createHierarchyList],
  props: {
    portalCustomers: {type:Array, required:true},
    value: {type:String, required:true}
  },
  data() {
    return {
      customerId: this.value,

      showAddProduct: false,
      showAddItem: false,
      showAddSpirit: false,
      showAddWine: false,
      id: '',

      allProducts: [],
      products: [],
      productCategories: [],

      allItems: [],
      items: [],
      itemCategories: [],

      allSpirits: [],
      spirits: [],

      allWines: [],
      wines: []
    }
  },
  watch: {
    value() {
      this.customerId = this.value;
      this.getInventory();
    }
  },
  computed: {
    customer() {
      return this.portalCustomers.find(customer => customer.customerId === this.customerId) ?? {products:[],items:[],spirits:[],wines:[]};
    },
    eligibleProducts() {
      return this.allProducts.filter(product => !this.products.some(id => id === product.id));
    },
    productsInCategories() {
      const categories = this.createHierarchyList(this.productCategories);
      for (const category of categories) {
        const sub = this.eligibleProducts.filter(product => product.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      const categoriesList = [...categories.filter(category => !category.disabled)];
      const categoriesList = categories;
      const leftOver = this.eligibleProducts.filter(product => !product.category?.id);
      if (leftOver.length)
        categoriesList.push({divider:true},{name:'Other products',id:'x',menu:leftOver})
      return categoriesList;
    },
    eligibleItems() {
      return this.allItems.filter(item => !this.items.some(id => id === item.id));
    },
    itemsInCategories() {
      const categories = this.createHierarchyList(this.itemCategories);
      for (const category of categories) {
        const sub = this.eligibleItems.filter(item => item.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      const categoriesList = [...categories.filter(category => !category.disabled)];
      const categoriesList = categories;
      const leftOver = this.eligibleItems.filter(item => !item.category?.id);
      if (leftOver.length)
        categoriesList.push({divider:true},{name:'Other items',id:'x',menu:leftOver})
      return categoriesList;
    },
    eligibleSpirits() {
      return this.allSpirits.filter(spirit => !this.spirits.some(id => id === spirit.id));
    },
    eligibleWines() {
      return this.allWines.filter(wine => !this.wines.some(id => id === wine.id));
    }
  },
  async created() {
    this.$lazyListLoad(this.productCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Product'}]);
    this.$lazyListLoad(this.itemCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]);
//    this.$lazyListLoad(this.allProducts, 'products2', 'id,name,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]);
//    this.$lazyListLoad(this.allItems, 'items2', 'id,name,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.allSpirits, 'spirits2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.allWines, 'wines2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);

    this.allProducts = (await this.$store.dispatch('products')).filter(product => product.active);
    this.allItems = (await this.$store.dispatch('items')).filter(item => item.active);

    if (this.customerId)
      this.getInventory();
  },
  methods: {
    async getInventory() {
      if (!this.customer.products) {
        const results = await this.$apiCall(`query AppsPortal($customerId:ID!) {
                                                portalCustomer(customerId:$customerId) {
                                                  products {productId}
                                                  items {itemId}
                                                  spirits {spiritId}
                                                  wines {wineId}
                                                }
                                            }`,
                                            {customerId:this.customerId}, false, 'portal');
        if (!results.error) {
          this.customer.products = results.data.portalCustomer.products.map(product => product.productId);
          this.customer.items = results.data.portalCustomer.items.map(item => item.itemId);
          this.customer.spirits = results.data.portalCustomer.spirits.map(spirit => spirit.spiritId);
          this.customer.wines = results.data.portalCustomer.wines.map(wine => wine.wineId);
        }
      }
      this.products = this.customer.products;
      this.items = this.customer.items;
      this.spirits = this.customer.spirits;
      this.wines = this.customer.wines;
    },
    async addProduct() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $productId:ID!) {
                                              portalProductCreate(customerId:$customerId, productId:$productId) {
                                                productId
                                              }
                                          }`,
                                          {customerId:this.customerId,productId:this.id}, false, 'portal');
      if (!results.error) {
        this.products.push(this.id);
        this.showAddProduct = false;
      }
    },
    async deleteProduct(productId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $productId:ID!) {
                                              portalProductDelete(customerId:$customerId, productId:$productId) {
                                                productId
                                              }
                                          }`,
                                          {customerId:this.customerId,productId}, false, 'portal');
      if (!results.error)
        this.products.splice(index,1);
    },
    async addItem() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $itemId:ID!) {
                                              portalItemCreate(customerId:$customerId, itemId:$itemId) {
                                                itemId
                                              }
                                          }`,
                                          {customerId:this.customerId,itemId:this.id}, false, 'portal');
      if (!results.error) {
        this.items.push(this.id);
        this.showAddItem = false;
      }
    },
    async deleteItem(itemId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $itemId:ID!) {
                                              portalItemDelete(customerId:$customerId, itemId:$itemId) {
                                                itemId
                                              }
                                          }`,
                                          {customerId:this.customerId,itemId}, false, 'portal');
      if (!results.error)
        this.items.splice(index,1);
    },
    async addSpirit() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $spiritId:ID!) {
                                              portalSpiritCreate(customerId:$customerId, spiritId:$spiritId) {
                                                spiritId
                                              }
                                          }`,
                                          {customerId:this.customerId,spiritId:this.id}, false, 'portal');
      if (!results.error) {
        this.spirits.push(this.id);
        this.showAddSpirit = false;
      }
    },
    async deleteSpirit(spiritId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $spiritId:ID!) {
                                              portalSpiritDelete(customerId:$customerId, spiritId:$spiritId) {
                                                spiritId
                                              }
                                          }`,
                                          {customerId:this.customerId,spiritId}, false, 'portal');
      if (!results.error)
        this.spirits.splice(index,1);
    },
    async addWine() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $wineId:ID!) {
                                              portalWineCreate(customerId:$customerId, wineId:$wineId) {
                                                wineId
                                              }
                                          }`,
                                          {customerId:this.customerId,wineId:this.id}, false, 'portal');
      if (!results.error) {
        this.wines.push(this.id);
        this.showAddWine = false;
      }
    },
    async deleteWine(wineId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $wineId:ID!) {
                                              portalWineDelete(customerId:$customerId, wineId:$wineId) {
                                                wineId
                                              }
                                          }`,
                                          {customerId:this.customerId,wineId}, false, 'portal');
      if (!results.error)
        this.wines.splice(index,1);
    }
  }
}
</script>